import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type ILeadProfile, leadProfilesManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const LEAD_PROFILE_MODULE = 'leadProfile';

const dataObjectModule = getDataObjectsModule<ILeadProfile>(leadProfilesManager);
const searchModule = getSearchModule<ILeadProfile>(leadProfilesManager);

const leadProfileModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(LEAD_PROFILE_MODULE, leadProfileModuleInstance);

export { LEAD_PROFILE_MODULE };
